import { RoleVSMenuInsert, RoleVSMenuInsertMany, RoleVSMenuDelete, RoleVSMenuUpdate, RoleVSMenuGetById, RoleVSMenuGetList, RoleVSMenuGetPageList } from "@/api/rolevsmenu/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    RoleVSMenuInsert(context, payload) {
        return new Promise((resolve, reject) => {
            RoleVSMenuInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 新增
    RoleVSMenuInsertMany(context, payload) {
        return new Promise((resolve, reject) => {
            RoleVSMenuInsertMany(payload).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    RoleVSMenuUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            RoleVSMenuUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    RoleVSMenuGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            RoleVSMenuGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    RoleVSMenuGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            RoleVSMenuGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    RoleVSMenuGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            RoleVSMenuGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}